<mat-card *ngIf="ready(); else progressSpinner">
  <mat-card-header>
    <mat-card-title>{{pageType | capitalize }} Lesson</mat-card-title>
  </mat-card-header>
  <form class="lesson-form">
    <mat-card-content>
      <mat-card-subtitle class="student">Details</mat-card-subtitle>
      <mat-form-field>
        <input matInput placeholder="Title"
               [formControl]="lessonForm.get('title')" required>
        <mat-error *ngIf="formService.controlHasError( lessonForm.get('title'), 'required')">This field is required
        </mat-error>
      </mat-form-field>
      <mat-form-field>
        <textarea matInput placeholder="Description"
                [formControl]="lessonForm.get('description')"></textarea>
        <mat-error *ngIf="formService.controlHasError( lessonForm.get('description'), 'required')">This field is required
        </mat-error>
      </mat-form-field>

      <!-- TODO: Add to data models -->
      <mat-card-subtitle class="student">Lesson Settings</mat-card-subtitle>
      <p><mat-slide-toggle [formControl]="lessonForm.get('strategyLessonEnabled')">Strategy Lesson</mat-slide-toggle></p>
      <p><mat-slide-toggle [formControl]="lessonForm.get('smartSaversEnabled')">Show Smartsavers</mat-slide-toggle></p>
      <p><mat-slide-toggle [formControl]="lessonForm.get('showCorrectEnabled')">Show Correct Answers</mat-slide-toggle></p>
      <p><mat-slide-toggle [formControl]="lessonForm.get('showMetricsEnabled')">Show Metrics</mat-slide-toggle></p>
      <p><mat-slide-toggle [formControl]="lessonForm.get('openAnswerOnComplete')">Open Answer on Complete</mat-slide-toggle></p>

      <!-- TODO: Does the field below need to be removed as well? -->
      <!--<p><mat-slide-toggle matInput>Open Answer on Complete</mat-slide-toggle></p>-->
    </mat-card-content>

    <!--Exercises-->
    <mat-card class="exercises-card" *ngIf="pageType==='edit' && lesson">
      <mat-card-title class="exercises-heading">
        <span>Exercises</span>
        <button mat-button color="primary"
                [routerLink]="['/courses/' + lesson.course.id + '/lessons/' + lesson.id + '/exercises/create/']">
          Add Exercise
        </button>
      </mat-card-title>
      <mat-card-content>
        <mat-accordion>
          <!--Exercise Start -->
          <mat-expansion-panel *ngFor="let exercise of lesson.exercises" [expanded]="false">
            <mat-expansion-panel-header class="draggable"
                                        draggable="true"
                                        (dragend)="dragEnd(exercise.id, lesson.exercises)"
                                        (dragstart)="sortListService.dragStart($event, exercise.id)"
                                        (dragenter)="sortListService.dragEnter($event, exercise.id)">
              <mat-panel-title>
                <mat-icon class="draggable">drag_handle</mat-icon>
                {{exercise.title}}
              </mat-panel-title>
              <button mat-button color="primary"
                      [routerLink]="['/courses/'+ lesson.course.id +'/lessons/' +lesson.id + '/exercises/' + exercise.id + '/manage']">
                Manage
              </button>
              <button mat-button color="primary"
                      [routerLink]="['/courses/'+ lesson.course.id +'/lessons/' +lesson.id + '/exercises/' + exercise.id + '/edit']">
                Edit
              </button>
            </mat-expansion-panel-header>
            <p>{{exercise.description}}</p>
            <mat-list>
              <mat-list-item class="w-50" style="float:left">
                <h3 mat-line>{{lesson.pacingGoal}}</h3>
                <p mat-line class="secondary-text">Pacing Goal (Total Minutes)</p>
              </mat-list-item>
              <mat-list-item class="w-50" style="float:left">
                <h3 mat-line>{{lesson.accuracyGoal}}</h3>
                <p mat-line class="secondary-text">Accuracy Goal (Percent Correct)</p>
              </mat-list-item>
            </mat-list>
          </mat-expansion-panel>
          <!--Exercise End -->
        </mat-accordion>
      </mat-card-content>
    </mat-card>
    <!--End Exercises-->

    <mat-card-actions class="lesson-actions" align="end">
      <button mat-raised-button color="primary" [disabled]="!lessonForm.valid || isSubmitting" (click)="submitForm()">
        {{buttonName}}
      </button>
    </mat-card-actions>
  </form>
</mat-card>

<ng-template #progressSpinner>
  <app-spinner></app-spinner>
</ng-template>
